import useSaveToHomePage from '@/app/hooks/useSaveToHomePage';
import { EPageSection } from '@/lib/enums';
import { PortalBootResponse } from '@/lib/types';
import { AddToHomePageModal, AddToHomeScreenButton } from '@/components/portal-ui';

import { StyledModalWrapper } from './style';
import { useTranslations } from 'next-intl';
import { isAndroid, isIOS } from 'react-device-detect';

interface AddToHomePagePortalProps {
  portalBoot: PortalBootResponse;
  className?: string;
  'data-page-section'?: EPageSection;
}

const AddToHomePagePortal = ({
  portalBoot,
  className = '',
  'data-page-section': dataPageSection,
  ...props
}: AddToHomePagePortalProps) => {
  const t = useTranslations();
  const {
    isSaveToHomePageOpen,
    setIsSaveToHomePageOpen,
    handleCloseSaveToHomePage,
    isDisplayAddToHomePageButton,
    handleInstallApp,
    isAndroidFallBack
  } = useSaveToHomePage(portalBoot);

  if (!isDisplayAddToHomePageButton) return null;

  const addToHomeScreen = portalBoot.settings?.addToHomeScreen;
  const isIOSBanner = isIOS && isSaveToHomePageOpen;
  const isAndroidBanner = isAndroid && isAndroidFallBack;

  const handleAddToHomeScreen = () => {
    if (isIOS) {
      setIsSaveToHomePageOpen(true);
    }
    if (isAndroid) {
      return handleInstallApp();
    }
  };

  return (
    <div className={className} data-page-section={dataPageSection}>
      <div data-testid="AddToHomePage-Button">
        <AddToHomeScreenButton
          onClick={handleAddToHomeScreen}
          borderColor={addToHomeScreen?.borderColor?.colorOne}
          backgroundColor={
            addToHomeScreen?.backgroundColor?.colorOne ? addToHomeScreen?.backgroundColor : undefined
          }
          buttonImage={addToHomeScreen?.buttonImage || ''}
          {...props}
        />
      </div>
      {(isIOSBanner || isAndroidBanner) && (
        <StyledModalWrapper data-testid="AddToHomePage-Modal">
          <AddToHomePageModal
            iconImage={
              addToHomeScreen?.iconImage ||
              'https://media.appcharge.com/defaults/default-store-logo.svg'
            }
            shortcutName={addToHomeScreen?.shortcutName || ''}
            isDarkMode={false}
            onClick={handleCloseSaveToHomePage}
            isAndroid={isAndroidBanner}
            translations={{
              installInstruction: t('portal.addToHomeModal.installInstruction', {
                companyName: addToHomeScreen?.shortcutName || ''
              }),
              description: t('portal.addToHomeModal.description'),
              moreInfoStep: t('portal.addToHomeModal.moreInfoStep'),
              shareStep: t('portal.addToHomeModal.shareStep'),
              addStep: t('portal.addToHomeModal.addStep')
            }}
            {...props}
          />
        </StyledModalWrapper>
      )}
    </div>
  );
};

export default AddToHomePagePortal;
